import {
  Configuration,
  Custom,
  LegalTextData,
  TutorialData,
} from '@core/models';

const custom: Custom = {
  paymentPage: {
    captureAddress: false,
    capturePhone: false,
  },
};

const seatSelectionTutorial: TutorialData = {
  desktop: {},
  mobile: {},
} as unknown as TutorialData;

const checkoutTutorial: TutorialData = {
  desktop: {},
  mobile: {},
} as unknown as TutorialData;

export const DefaultConfig: Configuration = {
  id: 'default',
  clientName: 'Local',
  appName: 'Local',
  city: 'Local',
  adas: true,
  favicon: '/assets/img/favicon3.png',
  rainout: false,
  upsells: true,
  logo: '/assets/img/logo34.svg',
  phone: '',
  email: '',
  paymentMethod: 'braintree',
  clientWebUrl: '',
  clientWebText: 'google.com',
  custom,
  clientBallParkUrl: '',
  termsOfUseUrl: 'https://www.mlb.com/official-information/terms-of-use',
  clientBallParkText: '',
  mlbShopUrl: '',
  merchandiseWebUrl: '',
  rainoutInsuranceUrl: '',
  termsAndConditionsUrl: '',
  analytics: '',
  theme: {
    'default-color': '0 90 156',
    'main-color': '23 52 130',
    'secondary-color': '25 149 255',
    'tertiary-color': '242 246 250',
    'accent-color': '189 48 57',
    red: '225 56 63',
    success: '86 163 67',
    'success-off-white': '236 246 232',
  },
  dvmData: {
    venueId: 'nam-us-00096-chicagocubs',
    mapId: 'main_venuemap',
    miniMapId: 'blockmap_split_minimap',
    miniMapEnabled: true,
    gaSectorsIdArray: [
      'S_501',
      'S_502',
      'S_503',
      'S_504',
      'S_505',
      'S_506',
      'S_507',
      'S_511',
      'S_512',
      'S_513',
      'S_514',
      'S_515',
      'S_536',
      'S_538',
      'S_537',
    ],
    gaAdaIdArray: [
      'S_CenterFieldADA',
      'S_LeftFieldADA',
      'S_RightFieldADA',
      'S_LeftFieldADA1',
      'S_LeftFieldADA2',
    ],
    sectionOffsets: {},
    limitedZoom: false,
  },
  cartSummaryText: 'Here you can see your new requested tickets',
  dvmStyles: {
    'seat-available-none-fill': '25 149 255',
    'seat-available-none-stroke': '0 90 156',
    'seat-available-disabled-fill': '25 149 255',
    'seat-available-disabled-stroke': '0 90 156',
    'seat-unavailable-none': '214 214 214',
    'seat-available-pending': '230 145 56',
    'section-available-normal-fill': '25 149 255',
    'section-available-normal-stroke': '0 90 156',
    'section-available-normal-group1-fill': '255 77 77',
    'section-available-normal-group1-stroke': '255 77 77',
    'section-available-hover-fill': '0 90 156',
    'section-available-hover-stroke': '255 255 255',
    'section-selected-normal-fill': '225 56 63',
    'section-selected-normal-stroke': '225 56 63',
    'section-selected-hover-stroke': '255 255 255',
    'section-nh-available-normal-fill': '229 154 65',
    'section-nh-available-normal-stroke': '229 154 65',
    'section-nh-available-hover-fill': '229 154 65',
    'section-nh-available-hover-stroke': '229 154 65',
    'section-nh-unavailable-normal-fill': 'transparent',
    'section-nh-unavailable-normal-stroke': 'transparent',
    'section-nh-unavailable-hover-fill': 'transparent',
    'section-nh-unavailable-hover-stroke': 'transparent',
  },
  tutorial: {
    seatSelection: seatSelectionTutorial,
    checkout: checkoutTutorial,
  },
  summaryPage: {
    image1: '',
    image2: '',
  },
  get legalText(): LegalTextData {
    return {
      links: {
        termsLink: {
          href: this.termsAndConditionsUrl,
          text: 'Terms and Conditions',
          target: '_blank',
        },
        clubWebLink: {
          href: this.clientWebUrl,
          text: this.clientWebText,
          target: '_blank',
        },
      },
      text: [
        `As part of your ticket purchase, you are required to acknowledge the {termsLink}.
        The Terms and conditions of your ticket and policies applicable to its use are updated to
        address circumstances related to COVID-19, health and safety, and seating pods.
        By clicking the Place Order button, you agree to accept all {termsLink} applicable to ticket purchase, and all related policies.
        Further, due to the COVID-19 pandemic, scheduling may be impacted and games may be canceled,
        rescheduled, postponed or games may be held with limited capacity. Games may also have restricted capacity that prevents the use of specific
        seats. In the event that the game(s) for which the ticket(s) is issued does not occur or you are unable to use the
        specific seat(s) purchased, a refund or credit will be issued according to the refund policy available at {clubWebLink}.`,

        `By selecting the Place Order button you agree to purchase the tickets selected, to accept any restrictions noted, and
        understand you are responsible for any payment needed to complete the purchase. Upon completing your purchase by
        selecting the Place Order button, you acknowledge and agree your credit card will be charged. All sales are final. All
        tickets are subject to the {termsLink}.`,

        `In connection with your purchase, you may receive customer service-related emails from the ${this.clientName}, including
        optional surveys regarding your gameday experience. You also may receive ticket-related commercial email from the
        ${this.clientName}. You may unsubscribe from ticket-related commercial emails at any time.`,
      ],
    };
  },
  defaultTooltipText: 'Review seats before continuing',
  teamId: '',
  metaPixelAnalytics: false,
};
